export const LOAD_ITEM_GROUPS = 'load_item_groups';
export const ITEM_GROUPS_LOADED = 'set_loaded_item_groups';
export const RESET_ITEM_GROUPS = 'reset_item_groups';
export const SYNC_FAILED = 'item_groups_sync_has_failed';
